// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"307":"cae3a96b","461":"95c32c1e","672":"7e3d83e7","705":"7e80f4af","814":"89ac166d"}[chunkId] + ".css";
};